import React from 'react';
import Navbar from '../../../components/navigation/Navbar';
import Calendar from '../../calendar/components/Calendar';
import StudentAnalytics from '../../../components/pages/StudentAnalyticsPageComponent';
import History from '../../../components/pages/HistoryPageComponent';
import StudentsPage from '../../../components/pages/StudentsPageComponent';

const SECTION_ALIASES = {
    '0': 'calendar',
    p: 'students',
    h: 'history',
    a: 'analytics',
    t: 'trainers'
};

export default function DiarySectionContent({ section, user }) {
    const normalizedSection = SECTION_ALIASES[section] || section;

    switch (normalizedSection) {
        case 'calendar':
            return <Calendar role={user.role} user={user} />;
        case 'students':
            return <StudentsPage />;
        case 'trainers':
            return (
                <div>
                    <h2 style={{ textAlign: 'center' }}>empty page</h2>
                    <Navbar usertype={user?.role} />
                </div>
            );
        case 'history':
            return <History />;
        case 'analytics':
            return <StudentAnalytics />;
        default:
            return null;
    }
}
